import { ISegmentDefinition } from '../../types';

export const BingAndYahooSearchTop: ISegmentDefinition = {
  segment: 'BingAndYahooSearchTop',
  titleKey: 'Segment_Page_Position_BingYahooTop',
};

export const BingAndYahooSearchOther: ISegmentDefinition = {
  segment: 'BingAndYahooSearchOther',
  titleKey: 'Segment_Page_Position_BingYahooOther',
};

export const AOLSearchTop: ISegmentDefinition = {
  segment: 'AOLSearchTop',
  titleKey: 'Segment_Page_Position_AOL_Top',
};

export const AOLSearchOther: ISegmentDefinition = {
  segment: 'AOLSearchOther',
  titleKey: 'Segment_Page_Position_AOL_Other',
};
